/**
 * Lightweight "Recently viewed" properties. Stored in localStorage; no backend.
 * Last 5–10 property IDs, most recent first. Prune when properties no longer exist.
 */

const STORAGE_KEY = 'wt-recent-properties';
const MAX_RECENT = 10;

function read(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

function write(ids: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // ignore
  }
}

/** Get recent property IDs (most recent first). */
export function getRecentPropertyIds(): string[] {
  return read();
}

/** Record a property view: add to front, dedupe, keep max MAX_RECENT. */
export function addRecentPropertyId(id: string): void {
  const ids = read();
  const next = [id, ...ids.filter((x) => x !== id)].slice(0, MAX_RECENT);
  write(next);
}

/** Remove IDs that are no longer in validIds; write back pruned list. */
export function pruneRecentPropertyIds(validIds: Set<string>): string[] {
  const ids = read();
  const pruned = ids.filter((x) => validIds.has(x));
  if (pruned.length !== ids.length) write(pruned);
  return pruned;
}
